import { render, staticRenderFns } from "./RiskHistoryForm.vue?vue&type=template&id=e090afb0"
import script from "./RiskHistoryForm.vue?vue&type=script&lang=js"
export * from "./RiskHistoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports